import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux-toolkit/store';
import { FeaturePermissionMatrix } from '@/apis/types';

// looks up a feature's permissions in state.menu.features by label, like useMenuPermissions does for menus
export const useFeaturePermissions = (
  label = ''
): FeaturePermissionMatrix | null => {
  const features = useSelector((state: RootState) => state.menu?.features);

  return useMemo(() => {
    if (!Array.isArray(features) || !label.trim()) return null;

    const normalizedLabel = label.trim().toLowerCase();
    const feature = features.find(
      (item) =>
        typeof item?.label === 'string' &&
        item.label.trim().toLowerCase() === normalizedLabel
    );

    return (feature?.permissions as FeaturePermissionMatrix) || null;
  }, [features, label]);
};

export default useFeaturePermissions;
